import { Link } from 'react-router-dom';
import React, { useState } from 'react';
const ContactSection = () => {
const [formData, setFormData] = useState({
name: '',
email: '',
message: ''
});
const handleInputChange = (e) => {
const { id, value } = e.target;
setFormData(prevState => ({
...prevState,
[id]: value
}));
};
const handleSubmit = (e) => {
e.preventDefault();
// Form submission logic would go here
console.log('Form submitted:', formData);
alert('Thank you for your message! We will get back to you soon.');
setFormData({ name: '', email: '', message: '' });
};
return (
<div className="contact padding-top padding-bottom contact-top-bottom">
   <div className="container">
      <div className="contact__wrapper">
         <div className="row ">
            {/* Contact Information */}
            <div className="col-md-5 new-shadow shadow-contact">
               <div className="contact__info" data-aos="fade-right" data-aos-duration="1000">
                  <div className="contact__social">
                     <h3>let’s <span className="style2">get in touch</span> with us</h3>
                     <ul className="social">
                        <li className="social__item">
                           <a href="#" className="social__link social__link--style4 active">
                           <i className="fab fa-facebook-f"></i>
                           </a>
                        </li>
                        <li className="social__item">
                           <a href="#" className="social__link social__link--style4 active">
                           <i className="fab fa-instagram"></i>
                           </a>
                        </li>
                        <li className="social__item">
                           <a href="#" className="social__link social__link--style4 active">
                           <i className="fa-brands fa-linkedin-in"></i>
                           </a>
                        </li>
                        <li className="social__item">
                           <a href="#" className="social__link social__link--style4 active">
                           <i className="fab fa-youtube"></i>
                           </a>
                        </li>
                        <li className="social__item">
                           <a href="#" className="social__link social__link--style4 active">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="22px" height="22px">
                                 <path
                                    d="M 2.3671875 3 L 9.4628906 13.140625 L 2.7402344 21 L 5.3808594 21 L 10.644531 14.830078 L 14.960938 21 L 21.871094 21 L 14.449219 10.375 L 20.740234 3 L 18.140625 3 L 13.271484 8.6875 L 9.2988281 3 L 2.3671875 3 z M 6.2070312 5 L 8.2558594 5 L 18.033203 19 L 16.001953 19 L 6.2070312 5 z"
                                    fill="#A6BD91" />
                              </svg>
                           </a>
                        </li>
                     </ul>
                  </div>
                  <div className="contact__details">
                     <div className="contact__item" data-aos="fade-right" data-aos-duration="1000">
                        <div className="contact__item-inner">
                           <div className="contact__item-thumb">
                              <span><img src="assets/images/contact/1.png" alt="contact-icon" className="dark" /></span>
                           </div>
                           <div className="contact__item-content">
                              <p>+0124-2980883, +0124-4383765</p>
                           </div>
                        </div>
                     </div>
                     <div className="contact__item" data-aos="fade-right" data-aos-duration="1100">
                        <div className="contact__item-inner">
                           <div className="contact__item-thumb">
                              <span><img src="assets/images/contact/2.png" alt="contact-icon" className="dark" /></span>
                           </div>
                           <div className="contact__item-content">
                              <p>asiaticstock@gmail.com</p>
                           </div>
                        </div>
                     </div>
                     <div className="contact__item" data-aos="fade-right" data-aos-duration="1200">
                        <div className="contact__item-inner">
                           <div className="contact__item-thumb">
                              <span><img src="assets/images/contact/3.png" alt="contact-icon" className="dark" /></span>
                           </div>
                           <div className="contact__item-content">
                              <p>Plot no 38, Road no-A27, DLF Phase-1, Gurugram, Haryana-122002</p>
                           </div>
                        </div>
                     </div>
                     <Link
                        to="/escalation-matrix"
                        className="btn btn-primary w-100 mt-4 py-2 d-flex align-items-center justify-content-center gap-3"
                        >
                        <span>Escalation Matrix</span>
                        <span
                           className="rounded-circle bg-white d-flex align-items-center justify-content-center"
                           style={{ width: '30px', height: '30px' }}
                        >
                           <i
                              className="fas fa-arrow-right"
                              style={{ transform: 'rotate(-45deg)', color: '#007bff' }}
                           ></i>
                        </span>
                     </Link>

                  </div>
               </div>
            </div>
            {/* Contact Form */}
            <div className="col-md-7 py-2">
               <div className="contact__form new-shadow p-5 shadow-contact">
                  <h3 className="mb-4">Send us a message</h3>
                  <form onSubmit={handleSubmit} data-aos="fade-left" data-aos-duration="1000">
                     <div className="row g-4">
                        <div className="col-12">
                           <div>
                              <label htmlFor="name" className="form-label">Name</label>
                              <input 
                                 className="form-control" 
                                 type="text" 
                                 id="name" 
                                 placeholder="Full Name"
                                 value={formData.name}
                                 onChange={handleInputChange}
                                 required 
                                 />
                           </div>
                        </div>
                        <div className="col-12">
                           <div>
                              <label htmlFor="email" className="form-label">Email</label>
                              <input 
                                 className="form-control" 
                                 type="email" 
                                 id="email" 
                                 placeholder="Email here"
                                 value={formData.email}
                                 onChange={handleInputChange}
                                 required 
                                 />
                           </div>
                        </div>
                        <div className="col-12">
                           <div>
                              <label htmlFor="message" className="form-label">Message</label>
                              <textarea 
                                 cols="30" 
                                 rows="6" 
                                 className="form-control" 
                                 id="message"
                                 placeholder="Enter Your Message"
                                 value={formData.message}
                                 onChange={handleInputChange}
                                 required
                                 ></textarea>
                           </div>
                        </div>
                     </div>
                     <button type="submit" className="trk-btn trk-btn--border trk-btn--primary mt-4 d-block">
                     <i className="fas fa-paper-plane me-2"></i> contact us now
                     </button>
                  </form>
               </div>
            </div>
         </div>
         <div className='new-shadow shadow-contact'>
            <h3 className="mb-4 d-flex align-items-center">
               <i className="fas fa-map-marker-alt me-3"></i>
               Location
            </h3>
            <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3504.5090211041434!2d77.0899123!3d28.4787373!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1fc54246f0b3%3A0xd72bb9225ea053fe!2sAsiatic%20Stock%20%26%20Securities%20Ltd.!5e0!3m2!1sen!2sin!4v1694265600000"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Company Location"
            ></iframe>
         </div>
      </div>
   </div>
</div>
);
};
export default ContactSection;